export const rankRowBg = (index) => {
  if (index === 0) return 'bg-yellow-400/15 border-yellow-400/30'
  if (index === 1) return 'bg-gray-300/10 border-gray-400/20'
  if (index === 2) return 'bg-orange-400/10 border-orange-400/20'
  return 'bg-base-200/40 border-base-300/50'
}

export const portfolioSummary = (entry) => {
  const picks = entry?.stocks ?? []
  if (picks.length === 0) return 'No picks'
  const topPick = picks.reduce((max, stock) => (stock.weight > max.weight ? stock : max), picks[0])
  return `${picks.length} picks • ${topPick.symbol} ${topPick.weight}%`
}
